var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"complainSus",style:({height: _vm.clientHeight+'px'})},[_c('img',{attrs:{"src":require("../../assets/img/ic-status-success.png"),"alt":""}}),_c('div',[_vm._v("提交成功，")]),_c('div',[_vm._v("您的评价会让我们做的更好")])])}
var staticRenderFns = []

export { render, staticRenderFns }